import React from 'react';
import { PropTypes, describe } from 'react-desc';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import DSSeparator from '@elliemae/ds-separator';
import styled from 'styled-components';

var blockName = 'menu-separator';
var Li = /*#__PURE__*/styled.li.withConfig({
  componentId: "aysbq3-0"
})(["display:flex;align-items:flex-start;flex-direction:column;"]);
var Title = aggregatedClasses('h5')(blockName, 'title');

var MenuSeparator = function MenuSeparator(_ref) {
  var title = _ref.title,
      _ref$showSeparator = _ref.showSeparator,
      showSeparator = _ref$showSeparator === void 0 ? true : _ref$showSeparator;
  return /*#__PURE__*/React.createElement(Li, null, showSeparator && /*#__PURE__*/React.createElement(DSSeparator, null), title && /*#__PURE__*/React.createElement(Title, null, title));
};

var props = {
  /** menu separator h5 title */
  title: PropTypes.string.description('menu separator h5 title'),

  /** toggle separator on and off */
  showSeparator: PropTypes.bool.description('toggle separator on and off')
};
MenuSeparator.propTypes = props;
var DSMenuSeparatorWithSchema = describe(MenuSeparator);
DSMenuSeparatorWithSchema.propTypes = props;

export default MenuSeparator;
export { DSMenuSeparatorWithSchema };
//# sourceMappingURL=Separator.js.map
